import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import axios from "axios";
import { getLinkedCalendars } from "services/ConfigServices";
import { linkedcalendartext } from "variables/MBM/schedule";
import moment from "moment";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddLinkedCalendar from "./AddLinkedCalendar";
import { NotificationManager } from "react-notifications";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: -8px;
`;


export default function useLinkedCalendarsTable(wpgroup) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getLinkedCalendars(wpgroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [selectedCalendars, setSelectedCalendars] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (wpgroup && wpgroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === wpgroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = wpgroup;
      fetchData();
    }
  }, [wpgroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `linkedcalendars`, []).filter(
    (item) =>
      (item.parameters?.name && item.parameters?.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.lastsynchronization && moment(item.lastsynchronization).isValid() && moment(item.lastsynchronization).format("DD/MM/YYYY HH:mm").includes(filterText))
  )
    ;

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedCalendars.map((item) => {
      let calendartoexport = {};
      calendartoexport[linkedcalendartext.id] = item.id;
      calendartoexport[linkedcalendartext.name] = item.parameters?.name;
      calendartoexport[linkedcalendartext.url] = item.parameters?.url;
      calendartoexport[linkedcalendartext.refreshtime] = item.parameters?.refreshtime;
      calendartoexport[linkedcalendartext.lastsynchronization] = item.lastsynchronization && moment(item.lastsynchronization).isValid() ? moment(item.lastsynchronization).format("DD/MM/YYYY HH:mm") : "";
      calendartoexport[linkedcalendartext.group] = groupInfoListById["" + item.groupid];
      return calendartoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_geb_control_schedules && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddLinkedCalendar refetch={refreshTable} onClick={handleClear} setLoading={setLoading} setNotification={setNotification} />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedCalendars || selectedCalendars.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedCalendars, results]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedCalendars,
    setLoading,
  };
}
